export const shuffle = (arr) => [...arr].sort(() => 0.5 - Math.random());

export const buildUrl = (url, params) => {
  let urlWithParams = url;

  Object.entries(params).forEach(([key, value], i) => {
    if (value !== undefined && value !== null && value !== '') {
      const sign = !i ? "?" : "&";
      urlWithParams += `${sign}${key}=${encodeURIComponent(value)}`;
    }
  });

  return urlWithParams;
};

export const sumBy = (arr) => arr.reduce((prev, cur) => prev + cur, 0);